import { createAction } from 'typesafe-actions';
import { Notification } from 'store/notifications/types';

export const showNotification = createAction('notifications/SHOW')<Omit<Notification, 'uuid'>>();

export const hideNotification = createAction('notifications/HIDE')<string>();
